<p class="card-progress__title" *ngIf="title">{{ title }}</p>

<!-- RING — radial progress -->
<div
  class="card-ring"
  *ngIf="variant === 'ring'"
  [attr.aria-label]="ringAriaLabel(label, safePercent, detail)"
  role="img">
  <svg class="card-ring__svg" viewBox="0 0 80 80" width="80" height="80" aria-hidden="true">
    <circle
      cx="40" cy="40" r="30"
      fill="none"
      stroke="var(--nova-border)"
      stroke-width="8"
      stroke-linecap="round"/>
    <circle
      cx="40" cy="40" r="30"
      fill="none"
      [attr.stroke]="'url(#card-ring-grad-' + uid + ')'"
      stroke-width="8"
      stroke-linecap="round"
      [attr.stroke-dasharray]="ringDasharray(safePercent)"
      stroke-dashoffset="0"
      transform="rotate(-90 40 40)"/>
    <defs>
      <linearGradient [attr.id]="'card-ring-grad-' + uid" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stop-color="var(--nova-accent)"/>
        <stop offset="100%" stop-color="var(--nova-accent-secondary)"/>
      </linearGradient>
    </defs>
  </svg>
  <div class="card-ring__center" aria-hidden="true">
    <span class="card-ring__percent">{{ safePercent }}%</span>
  </div>
  <div class="card-ring__labels">
    <span class="card-ring__label" *ngIf="label">{{ label }}</span>
    <span class="card-ring__detail" *ngIf="detail">{{ detail }}</span>
  </div>
</div>

<!-- BARS — labelled linear progress bars -->
<div class="card-pbars" *ngIf="variant === 'bars' && bars?.length">
  <div
    class="card-pbars__row"
    *ngFor="let bar of bars"
    [attr.aria-label]="barAriaLabel(bar)"
    role="img">
    <span class="card-pbars__label">{{ bar.label }}</span>
    <div class="card-pbars__track" role="presentation">
      <div
        class="card-pbars__fill"
        [style.width.%]="clampPercent(bar.percent)"
        aria-hidden="true"></div>
    </div>
    <span class="card-pbars__detail" *ngIf="anyBarDetail">{{ barText(bar) }}</span>
  </div>
</div>

<!-- LADDER — stepped positional scale -->
<div class="card-ladder" *ngIf="variant === 'ladder' && steps?.length">
  <div
    class="card-ladder__rung"
    *ngFor="let rung of ladderRungs(steps || []); let last = last"
    [class.card-ladder__rung--current]="rung.step.current"
    [class.card-ladder__rung--filled]="rung.filled">
    <div class="card-ladder__node-wrap">
      <div class="card-ladder__node" aria-hidden="true">
        <div class="card-ladder__node-dot" [class.card-ladder__node-dot--filled]="rung.filled"></div>
      </div>
      <div
        class="card-ladder__line"
        *ngIf="!last"
        [class.card-ladder__line--filled]="rung.connectorFilled"
        aria-hidden="true"></div>
    </div>
    <span class="card-ladder__label" [class.card-ladder__label--current]="rung.step.current">
      {{ rung.step.label }}
    </span>
  </div>
</div>
